import { PlatformLocation } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CHECK24_LOCAL_HOSTNAMES } from '../../config/check24-environment.config';
import {
  check24KreditAppHostname,
  check24WwwOrigin,
} from '../../config/check24-environment';

export const testGuard: CanActivateFn = () => {
  const hostname = inject(PlatformLocation).hostname;
  const isLocal = (CHECK24_LOCAL_HOSTNAMES as readonly string[]).includes(
    hostname,
  );
  if (isLocal || hostname === check24KreditAppHostname('non-prod')) {
    return true;
  }
  window.location.href = `${check24WwwOrigin('prod')}/kredit`;
  return false;
};
